<template>
    <div class="hero__form">
        <form class="form-default" autocomplete="off">
            <!-- Districts -->
            <div class="col">
                <districts-dropdown v-model="filters.districts"></districts-dropdown>
            </div>

            <!-- Metro -->
            <div class="col">
                <metro-dropdown v-model="filters.metro"></metro-dropdown>
            </div>

            <!-- Rooms count -->
            <div class="col">
                <div class="list-dropdown">
                    <input type="checkbox" id="heroLd3" class="list-dropdown__trigger">
                    <div class="list-dropdown__wrapper">
                        <label class="list-dropdown__title" for="heroLd3">
                            <span class="title">Количество комнат</span>
                        </label>
                        <div class="list-dropdown__container">
                            <div class="list-dropdown__content">
                                <room-numbers-list :min="0" :max="4" v-model="filters.roomTypes"></room-numbers-list>
                            </div>
                        </div>
                        <div class="list-dropdown__bg"></div>
                    </div>
                </div>
            </div>

            <!-- Price -->
            <div class="col">
                <label class="input-container">
                    <span class="input-container__prefix">до</span>
                    <span class="input-container__postfix"><i class="ruble"></i></span>
                    <input type="number" placeholder="10 000 000" v-model.number="filters.price.maximum">
                </label>
            </div>
            <a :href="action + queryString" type="button" class="button-square">Поиск</a>
        </form>
    </div>
</template>

<script>
    // Libs
    import qs from 'qs';

    /* Vue Components */
    import roomNumbersList from './RoomNumbersList.vue';
    import metroDropdown from './MetroDropdown.vue';
    import districtsDropdown from './DistrictsDropdown.vue';

    export default {
        props: {
            action: {
                type: String,
                default: '/catalog/'
            }
        },
        data() {
            return {
                filters: {
                    districts: [],
                    metro: [],
                    roomTypes: [],
                    price: { maximum: null }
                },
                inProgress: false
            }           
        },
        computed: {
            query() {
                return {
                    districts: this.filters.districts,
                    metro: this.filters.metro.map(x => x.station), // only difference :)
                    roomTypes: this.filters.roomTypes,
                    price: this.filters.price
                }
            },
            queryString() {
                let result = qs.stringify(this.query, {
                    skipNulls: true
                });
                return result ? ('?' + result) : '';
            }
        },
        components: {
            roomNumbersList,
            metroDropdown,
            districtsDropdown
        }
    }
</script>